import { render } from "./luntang.vue?vue&type=template&id=5cd96808&scoped=true"
import script from "./luntang.vue?vue&type=script&lang=js"
export * from "./luntang.vue?vue&type=script&lang=js"

import "./luntang.vue?vue&type=style&index=0&id=5cd96808&lang=less&scoped=scoped"
import "./luntang.vue?vue&type=style&index=1&id=5cd96808&lang=less"

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd96808"]])

export default __exports__